__turbopack_context__.v({
  "arrow": "ks1uuG_arrow",
  "checkIcon": "ks1uuG_checkIcon",
  "container": "ks1uuG_container",
  "content": "ks1uuG_content",
  "count": "ks1uuG_count",
  "description": "ks1uuG_description",
  "effortBadge": "ks1uuG_effortBadge",
  "findingDescription": "ks1uuG_findingDescription",
  "findingTitle": "ks1uuG_findingTitle",
  "header": "ks1uuG_header",
  "headerIcon": "ks1uuG_headerIcon",
  "headerText": "ks1uuG_headerText",
  "item": "ks1uuG_item",
  "list": "ks1uuG_list",
  "meta": "ks1uuG_meta",
  "sectionLabel": "ks1uuG_sectionLabel",
  "title": "ks1uuG_title",
});
